import Action5thEdition from "../schemas/actions/5thEdition.json";
import Action5e24 from "../schemas/actions/5e24.json";
import ActionPfrpg from "../schemas/actions/Pfrpg.json";
import ActionPfrpg2 from "../schemas/actions/Pfrpg2.json";
import ActionPfPlaytest from "../schemas/actions/PfPlaytest.json";
import ActionSolarianConflict from "../schemas/actions/SolarianConflict.json";
import ActionSavageEmbers from "../schemas/actions/SavageEmbers.json";
import ActionSavageWorlds from "../schemas/actions/SavageWorlds.json";
import ActionEmbersRpg from "../schemas/actions/EmbersRpg.json";

import SheetFifthEdition from "../schemas/characters/5thEdition.json";
import Sheet5e24 from "../schemas/characters/5e24.json";
import SheetPfrpg from "../schemas/characters/Pfrpg.json";
import SheetPfrpg2 from "../schemas/characters/Pfrpg2.json";
import SheetPfPlaytest from "../schemas/characters/PfPlaytest.json";
import SheetSolarianConflict from "../schemas/characters/SolarianConflict.json";
import SheetSavageEmbers from "../schemas/characters/SavageEmbers.json";
import SheetSavageWorlds from "../schemas/characters/SavageWorlds.json";
import SheetEmbersRpg from "../schemas/characters/EmbersRpg.json";

import Item5thEdition from "../schemas/items/5thEdition.json";
import Item5e24 from "../schemas/items/5e24.json";
import ItemPfrpg from "../schemas/items/Pfrpg.json";
import ItemPfrpg2 from "../schemas/items/Pfrpg2.json";
import ItemPfPlaytest from "../schemas/items/PfPlaytest.json";
import ItemSolarianConflict from "../schemas/items/SolarianConflict.json";
import ItemSavageEmbers from "../schemas/items/SavageEmbers.json";
import ItemSavageWorlds from "../schemas/items/SavageWorlds.json";
import ItemEmbersRpg from "../schemas/items/EmbersRpg.json";

import Note5thEdition from "../schemas/notes/5thEdition.json";
import Note5e24 from "../schemas/notes/5e24.json";
import NotePfrpg from "../schemas/notes/Pfrpg.json";
import NotePfrpg2 from "../schemas/notes/Pfrpg2.json";
import NotePfPlaytest from "../schemas/notes/PfPlaytest.json";
import NoteSolarianConflict from "../schemas/notes/SolarianConflict.json";
import NoteSavageEmbers from "../schemas/notes/SavageEmbers.json";
import NoteSavageWorlds from "../schemas/notes/SavageWorlds.json";
import NoteEmbersRpg from "../schemas/notes/EmbersRpg.json";

import Rule5thEdition from "../schemas/rules/5thEdition.json";
import Rule5e24 from "../schemas/rules/5e24.json";
import RulePfrpg from "../schemas/rules/Pfrpg.json";
import RulePfrpg2 from "../schemas/rules/Pfrpg2.json";
import RulePfPlaytest from "../schemas/rules/PfPlaytest.json";
import RuleSolarianConflict from "../schemas/rules/SolarianConflict.json";
import RuleSavageEmbers from "../schemas/rules/SavageEmbers.json";
import RuleSavageWorlds from "../schemas/rules/SavageWorlds.json";
import RuleEmbersRpg from "../schemas/rules/EmbersRpg.json";

import Skill5thEdition from "../schemas/skills/5thEdition.json";
import Skill5e24 from "../schemas/skills/5e24.json";
import SkillPfrpg from "../schemas/skills/Pfrpg.json";
import SkillPfrpg2 from "../schemas/skills/Pfrpg2.json";
import SkillPfPlaytest from "../schemas/skills/PfPlaytest.json";
import SkillSolarianConflict from "../schemas/skills/SolarianConflict.json";
import SkillSavageEmbers from "../schemas/skills/SavageEmbers.json";
import SkillSavageWorlds from "../schemas/skills/SavageWorlds.json";
import SkillEmbersRpg from "../schemas/skills/EmbersRpg.json";

import Spell5thEdition from "../schemas/spells/5thEdition.json";
import Spell5e24 from "../schemas/spells/5e24.json";
import SpellPfrpg from "../schemas/spells/Pfrpg.json";
import SpellPfrpg2 from "../schemas/spells/Pfrpg2.json";
import SpellPfPlaytest from "../schemas/spells/PfPlaytest.json";
import SpellSolarianConflict from "../schemas/spells/SolarianConflict.json";
import SpellSavageEmbers from "../schemas/spells/SavageEmbers.json";
import SpellSavageWorlds from "../schemas/spells/SavageWorlds.json";
import SpellEmbersRpg from "../schemas/spells/EmbersRpg.json";

import Trackable5thEdition from "../schemas/trackables/5thEdition.json";
import Trackable5e24 from "../schemas/trackables/5e24.json";
import TrackablePfrpg from "../schemas/trackables/Pfrpg.json";
import TrackablePfrpg2 from "../schemas/trackables/Pfrpg2.json";
import TrackablePfPlaytest from "../schemas/trackables/PfPlaytest.json";
import TrackableSolarianConflict from "../schemas/trackables/SolarianConflict.json";
import TrackableSavageEmbers from "../schemas/trackables/SavageEmbers.json";
import TrackableSavageWorlds from "../schemas/trackables/SavageWorlds.json";
import TrackableEmbersRpg from "../schemas/trackables/EmbersRpg.json";

/* arrays */
export const ActionSchemas = [
  Action5thEdition,
  Action5e24,
  ActionPfrpg,
  ActionPfrpg2,
  ActionPfPlaytest,
  ActionSolarianConflict,
  ActionSavageEmbers,
  ActionSavageWorlds,
  ActionEmbersRpg
];
export const SheetSchemas = [
  SheetFifthEdition,
  Sheet5e24,
  SheetPfrpg,
  SheetPfrpg2,
  SheetPfPlaytest,
  SheetSolarianConflict,
  SheetSavageEmbers,
  SheetSavageWorlds,
  SheetEmbersRpg
];
export const ItemSchemas = [
  Item5thEdition,
  Item5e24,
  ItemPfrpg,
  ItemPfrpg2,
  ItemPfPlaytest,
  ItemSolarianConflict,
  ItemSavageEmbers,
  ItemSavageWorlds,
  ItemEmbersRpg
];
export const NoteSchemas = [
  Note5thEdition,
  Note5e24,
  NotePfrpg,
  NotePfrpg2,
  NotePfPlaytest,
  NoteSolarianConflict,
  NoteSavageEmbers,
  NoteSavageWorlds,
  NoteEmbersRpg
];
export const RuleSchemas = [
  Rule5thEdition,
  Rule5e24,
  RulePfrpg,
  RulePfrpg2,
  RulePfPlaytest,
  RuleSolarianConflict,
  RuleSavageEmbers,
  RuleSavageWorlds,
  RuleEmbersRpg
];
export const SkillSchemas = [
  Skill5thEdition,
  Skill5e24,
  SkillPfrpg,
  SkillPfrpg2,
  SkillPfPlaytest,
  SkillSolarianConflict,
  SkillSavageEmbers,
  SkillSavageWorlds,
  SkillEmbersRpg
];
export const SpellSchemas = [
  Spell5thEdition,
  Spell5e24,
  SpellPfrpg,
  SpellPfrpg2,
  SpellPfPlaytest,
  SpellSolarianConflict,
  SpellSavageEmbers,
  SpellSavageWorlds,
  SpellEmbersRpg
];
export const TrackableSchemas = [
  Trackable5thEdition,
  Trackable5e24,
  TrackablePfrpg,
  TrackablePfrpg2,
  TrackablePfPlaytest,
  TrackableSolarianConflict,
  TrackableSavageEmbers,
  TrackableSavageWorlds,
  TrackableEmbersRpg
];
